import { inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import type { ActivatedRouteSnapshot } from '@angular/router';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs';

interface HighlightBanner {
    highlightBanner?: {
        showGlobalBanner?: boolean;
        showDealerBanner?: boolean;
    };
}
function collectData(snapshot: ActivatedRouteSnapshot): Record<string, unknown> {
    const combinedData: Record<string, unknown> = { ...snapshot.data };

    for (const child of snapshot.children) {
        Object.assign(combinedData, collectData(child));
    }
    return combinedData;
}

export function getHighlightBannerData() {
    const router = inject(Router);

    return toSignal(
        router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => collectData(router.routerState.snapshot.root) as HighlightBanner),
            tap((data) => data.highlightBanner),
            takeUntilDestroyed(),
        ),
    );
}
